import { getSlots, getUnslottedChildren } from "@/mds/utils/slots";
import { StyledSection, StyledSectionHeader, StyledSectionHeaderText } from "./section.style";
import { MdsSectionProps, MDSSectionSlotName } from "./section.types";

export const MDSSection = ({ title, children }: MdsSectionProps) => {
  const headerRightAddon = getSlots(children, MDSSectionSlotName.HeaderRightAddon);
  const content = getUnslottedChildren(children);

  return (
    <StyledSection>
      <StyledSectionHeader>
        {title && <StyledSectionHeaderText>{title}</StyledSectionHeaderText>}
        {headerRightAddon}
      </StyledSectionHeader>

      {content}
    </StyledSection>
  );
};
